import { Link } from 'react-router-dom'
import { Mail, Instagram, Twitter, Youtube, ArrowRight } from 'lucide-react'

const footerLinks = {
  Company: [
    { label: 'About Heritage', to: '/about' },
    { label: 'Journal', to: '/blog' },
    { label: 'Careers', to: '/careers' },
    { label: 'Press', to: '/press' },
    { label: 'Contact', to: '/contact' },
  ],
  Support: [
    { label: 'Help Center', to: '/help-center' },
    { label: 'Privacy Policy', to: '/privacy' },
    { label: 'Terms of Service', to: '/terms' },
    { label: 'Cookie Policy', to: '/cookie-policy' },
    { label: 'Accessibility', to: '/accessibility' },
  ],
}

const socialLinks = [
  { icon: Instagram, label: 'Instagram', href: '#' },
  { icon: Twitter, label: 'Twitter / X', href: '#' },
  { icon: Youtube, label: 'YouTube', href: '#' },
  { icon: Mail, label: 'Email', href: 'mailto:support@indianheritagetrust.com' },
]

const Footer = () => (
  <footer className="bg-museum-ivory border-t border-museum-antique-gold/15">
    <div className="px-6 md:px-10 max-w-[1320px] mx-auto pt-20 pb-16 md:pt-28 md:pb-20">
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-12 gap-y-12 gap-x-8 lg:gap-x-10">
        {/* Brand column */}
        <div className="col-span-2 lg:col-span-5">
          <Link to="/" className="inline-flex items-center gap-2.5 mb-6">
            <div className="w-7 h-7 border border-museum-antique-gold/50 flex items-center justify-center">
              <span className="text-museum-antique-gold font-editorial italic text-sm leading-none">H</span>
            </div>
            <span className="font-sans font-medium text-museum-black uppercase tracking-[0.28em] text-xs">
              Heritage
            </span>
          </Link>

          <p className="text-museum-black/55 font-sans text-sm leading-relaxed mb-8 max-w-sm">
            A digital archive for India's cultural legacy — documented,
            preserved, and shared with the rigor a museum brings to its own
            collection.
          </p>

          {/* Newsletter */}
          <div className="mb-8">
            <p className="text-[10px] uppercase tracking-[0.28em] text-museum-antique-gold font-sans font-semibold mb-3">
              Stay Informed
            </p>
            <div className="flex items-stretch gap-2 max-w-xs">
              <input
                type="email"
                placeholder="your@email.com"
                className="flex-1 min-w-0 bg-transparent border-b border-museum-black/20 px-0.5 py-2 text-museum-black font-sans text-sm placeholder-museum-black/30 focus:outline-none focus:border-museum-antique-gold transition-colors"
              />
              <button aria-label="Subscribe" className="px-3 text-museum-antique-gold hover:text-museum-black transition-colors flex-shrink-0 flex items-center justify-center">
                <ArrowRight size={15} />
              </button>
            </div>
          </div>

          {/* Social links */}
          <div className="flex gap-2">
            {socialLinks.map((social) => {
              const Icon = social.icon
              return (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  className="w-8 h-8 border border-museum-black/10 flex items-center justify-center text-museum-black/45 hover:border-museum-antique-gold hover:text-museum-antique-gold transition-all duration-300"
                >
                  <Icon size={13} />
                </a>
              )
            })}
          </div>
        </div>

        {/* Link columns */}
        {Object.entries(footerLinks).map(([category, links], i) => (
          <div key={category} className={`lg:col-span-3 ${i === 1 ? 'lg:col-start-10' : 'lg:col-start-7'}`}>
            <h4 className="font-sans font-medium text-museum-black uppercase tracking-[0.22em] text-[10px] mb-5">
              {category}
            </h4>
            <ul className="space-y-3">
              {links.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-museum-black/55 font-sans text-sm hover:text-museum-antique-gold transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>

    {/* Hairline before copyright */}
    <div className="px-6 md:px-10 max-w-[1320px] mx-auto">
      <div className="h-px bg-museum-antique-gold/15" />
    </div>

    <div className="px-6 md:px-10 max-w-[1320px] mx-auto py-6">
      <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
        <p className="text-museum-black/40 font-sans text-xs">
          &copy; 2026 Heritage Digital Archive. All rights reserved.
        </p>
        <p className="text-museum-black/40 font-sans text-xs">
          support@indianheritagetrust.com
        </p>
      </div>
    </div>
  </footer>
)

export default Footer
